import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import FamilyDocumentsBloc from "../blocs/info-beneficiary/FamilyDocumentsBloc";

export default function FamilyDocumentsPage() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Ajoutez un justificatif de situation familiale</h1>
        <p className="text ml-lg-desktop mt-sm" style={{textAlign: 'justify'}}>Des documents complémentaires sont nécessaires pour assurer la couverture de vos ayants droit.</p>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
            <FamilyDocumentsBloc />
        </div>
      </div>
    )

}